import { render, staticRenderFns } from "./ReviewYourAnswersNLCR.vue?vue&type=template&id=43f3f503"
import script from "./ReviewYourAnswersNLCR.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersNLCR.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports